<template>
  <ElcEmployee v-if="isElcEmployee"></ElcEmployee>
  <StarbucksEmployee v-else-if="isStarBucksEmployee" :employeeInfo="employeeInfo"></StarbucksEmployee>
  <Common v-else></Common>
</template>

<script>
import Common from './common'
import StarbucksEmployee from './custom/employee/starbucks'
import ElcEmployee from './custom/employee/elc'

export default {
  components: {
    ElcEmployee, Common, StarbucksEmployee
  },
  props: {
    personalInfo: {
      required: true
    }
  },
  data () {
    return {

    }
  },
  computed: {
    employeeInfo () {
      return this.personalInfo.employee
    },
    isElcEmployee () {
      return this.employeeInfo?.company?.root_company.id === 6172
    },
    isStarBucksEmployee () {
      return this.employeeInfo?.company?.root_company.id === 3738
    }
  },
  created () {
    this.$eventBus.$on('showActiveEmployeeContainer', this.employeeInfo && !this.isElcEmployee && !this.isStarBucksEmployee)
  },
  methods: {

  }
}
</script>

<style lang="scss" scoped>

</style>
